<section class="title">
  <i class="fa-light fa-circle-exclamation"></i>
  <h2 class="heading-5">
    {{ data.titleText || 'Something went wrong' }}
  </h2>
</section>

<p class="body mt-12">
  {{ data.descriptionText || "Please try again now, or we'll retry in" }}
  <span class="bold"> {{ countDownTimer }} {{ countDownTimer === 1 ? 'second' : 'seconds' }} </span>
</p>
<small class="hint mt-8">
  {{ data.smallDescription || "If it's still not working, please come back later" }}
</small>

<section class="actions mt-16">
  <app-button dataLabel="retry-try-again" (onClick)="dialogRef.close(true)">
    {{ data.confirmText || 'Try again now' }}
  </app-button>
</section>

<button (click)="dialogRef.close(true)" class="close-button">
  <i class="fa-regular fa-xmark"></i>
</button>
